export default "__VITE_ASSET__d283d7fa__"